angular.module('ihestiaWidgets.ikonfigurator')
  .directive('ihestiaIkonfigurator', [function(){
    return {
      scope: {}, // {} = isolate, true = child, false/undefined = no change
      restrict: 'E', // E = Element, A = Attribute, C = Class, M = Comment
      templateUrl: 'ihestia-widgets-templates-app/ikonfigurator/ikonfigurator.tpl.html'
    };
  }]);